import { orchestrator } from 'satcheljs';
import { onFluidLinkCreated } from 'owa-link-data';
import { onFluidFileCreationFailed, onFluidFileLoadFailure } from 'owa-fluid-link';
import {
    addShareLink,
    setFluidLinkFailed,
    resetCollabSpaceStore,
    setIsCollabSpacePresent,
} from '../mutators/collabSpaceMutators';
import { isChapterTwoScenario } from 'owa-fluid-validations';
import { reportPerfCheckmark, OWAFluidCheckmarksEnum } from 'owa-fluid-perf-datapoints';
import { onFluidComponentRendered } from 'owa-fluid-integrations';

orchestrator(onFluidFileCreationFailed, actionMessage => {
    if (isChapterTwoScenario(actionMessage.owaSource)) {
        resetCollabSpaceStore(actionMessage.viewStateId);
        setFluidLinkFailed(true, actionMessage.viewStateId);
    }
});

orchestrator(onFluidLinkCreated, actionMessage => {
    if (isChapterTwoScenario(actionMessage.owaSource)) {
        reportPerfCheckmark(OWAFluidCheckmarksEnum.fluidFileLoaded, actionMessage.owaSource);
        addShareLink(actionMessage.url, actionMessage.viewStateId);
        setFluidLinkFailed(false, actionMessage.viewStateId);
    }
});

orchestrator(onFluidFileLoadFailure, actionMessage => {
    if (isChapterTwoScenario(actionMessage.owaSource)) {
        setFluidLinkFailed(true, actionMessage.viewStateId);
    }
});

orchestrator(onFluidComponentRendered, actionMessage => {
    if (
        isChapterTwoScenario(actionMessage.owaSource) &&
        actionMessage.isCreateNew &&
        actionMessage.viewStateId
    ) {
        setIsCollabSpacePresent(true, actionMessage.viewStateId);
    }
});
